// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"6":"component---src-pages-index-2-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js","913":"af4000f3fe1cfbe71df4b32de1ebbaf80ef1d2a0"}[chunkId] + "-" + {"6":"cd2b12cbf0cfdaa53050","678":"18b742319a097f93743e","883":"8f04156d83819fd4d9b4","913":"3850839a2ee66cf1280a"}[chunkId] + ".js";
};